import NP from "number-precision";
import Offer from "domain/offer"
import { OfferTypeEnum } from "domain/offerType"
import { OfferStatus } from "domain/offerStatus";
import { OrderType } from "domain/orderType";

export function calculateRequiredFuturesPrice(offer: Offer, isCashOnly?: boolean) {
    if (isCashOnly ?? offer.deliveryPeriod?.commodity?.isCashOnly) return null;

    if (offer.isPriceAtOpenEnabled) return null;

    if (offer.orderType === OrderType.Tas && offer.status !== OfferStatus.Filled) {
        return offer.cashPrice;
    }

    switch (offer.type) {
        case OfferTypeEnum.Cash:
        case OfferTypeEnum.CashMinPrice:
        case OfferTypeEnum.FixFuturesOnBasis:
        case OfferTypeEnum.FixBasisOnHta:
            if (offer.status === OfferStatus.Filled) {
                return NP.minus(offer.cashPrice ?? 0, offer.basis ?? 0);
            }
            return NP.minus(offer.cashPrice ?? 0, offer.isBasisFixed ? (offer.basis ?? 0) : (offer.currentBasis ?? 0));
        case OfferTypeEnum.Hta:
        case OfferTypeEnum.HtaMinPrice:
            return offer.cashPrice;
        case OfferTypeEnum.BasisOffer:
            return null;
        default:
            return offer.cashPrice;
    }
}

export function calculateToHit(offer: Offer): number {
    if (offer.deliveryPeriod.commodity.isCashOnly) {
        return offer.customerWillSell
            ? NP.minus(offer.cashPrice, offer.bid.cash)
            : NP.minus(offer.bid.cash, offer.cashPrice);
    }
    else if (offer.type === OfferTypeEnum.BasisOffer) {
        return offer.customerWillSell
            ? NP.minus(offer.basis, offer.currentBasis)
            : NP.minus(offer.currentBasis, offer.basis);
    }
    else {
        const requiredPrice = calculateRequiredFuturesPrice(offer);
        return offer.customerWillSell
            ? NP.minus(requiredPrice, offer.futuresContract.price)
            : NP.minus(offer.futuresContract.price, requiredPrice);
    }

}